module.exports = __webpack_public_path__ + "img/palmar-resort.5d595647.jpg";